import React from "react"
import Favorite, { FavoriteButton } from "../../../FavoriteButton"
import { withRouter } from "react-router"

const AddToFavoritesBtn = (props) => {
  const { product } = props

  return (
    <Favorite
      className="rounded button-item"
      trackingLocation="Insights Report Page"
      favoriteData={{
        name: product.name,
        description: product.previewDescription,
        favoriteType: "REPORT",
        slug: props.location.pathname,
        metadata: {
          productId: product.id,
          imageURL: product.logo,
        },
      }}
      favoriteType="REPORT"
      location={props.location}
      variables={{ productId: product.id }}
    >
      <FavoriteButton className="btn-favorite-outline-orange rounded button-item" />
    </Favorite>
  )
}

export default withRouter(AddToFavoritesBtn)
